import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IDepartmentsInfoSetupFieldsPanel {
	departmentDDLItems: any;
	onDepartmentSelectionChangeHandler: (value: any) => void;
}
export const DepartmentsInfoSetupFieldsPanel: FC<
	IDepartmentsInfoSetupFieldsPanel
> = ({ departmentDDLItems, onDepartmentSelectionChangeHandler }) => {
	// RESPONSIVE
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;
	return (
		<Box
		// sx={{
		// 	padding: "0",
		// 	"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
		// }}
		>
			{mobileTabOrSmallLaptopScreen && <EnhancedDropDownRHFWithLabel
				label="Load Department"
				selectName="department"
				testId={`department`}
				labelPosition={LabelPosition.Top}
				items={departmentDDLItems ?? []}
				onSelectionChangeHandler={onDepartmentSelectionChangeHandler}
				showEmpty
			/>}
			<RHookFormTextFieldWithLabel
				label="Id"
				id="code"
				testId={`code`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Name"
				id="departmentName"
				testId={`account-title`}
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={7}
			// required
			/>
			<EnhancedTextAreaFieldRHF
				label="Notes"
				id="notes"
				testId={`notes`}
				// placeholder="Notes"
				labelPosition={LabelPosition.Top}
			// labelColumns={4}
			// fieldColumns={7}
			/>
		</Box>
	);
};
